import React, { useEffect, useRef, useState } from "react";
import { Box, IconButton, Typography, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomSelect from "components/ui/FilterModal/CustomSelect";
import Modal from "components/ui/Modal";

const modalStyle = {
  //   position: "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   width: 360,
  backgroundColor: "#fff",
  borderRadius: "12px",
  //   padding: "20px",
};

const EditSelectModal = ({ open, onClose, title, value, options, name, onSave, btnTitle, placeHolder, btnInfo }) => {
  const [fields, setFields] = useState(btnInfo || []);
  const [selectedValue, setSelectedValue] = useState(value);
  const [openState, setOpenState] = useState(false);

  const inputRefs = useRef([]);

  useEffect(() => {
    setFields(btnInfo || []);
  }, [btnInfo]);

  const handleInputChange = (index, inputValue) => {
    const updated = [...fields];
    const field = updated[index];

    let value = inputValue;

    if (field.onlyNumber) {
      value = value.replace(/[^0-9.]/g, "");
    }

    updated[index].value = value;
    setFields(updated);
  };

  const handleCursor = (index) => {
    const input = inputRefs.current[index];
    const field = fields[index];

    if (!input || !field?.suffix) return;

    const valueLength = (field.value || "").length;

    // ✅ always place cursor before suffix
    setTimeout(() => {
      input.setSelectionRange(valueLength, valueLength);
    }, 0);
  };

  // check required fields
  const isValid = fields.every((item) => !item.required || (item.value && item.value.trim() !== ""));

  useEffect(() => {
    setSelectedValue(value);
  }, [value, open]);

  const isChanged = selectedValue !== value;

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleSave = () => {
    if (btnInfo) {
      if (!isValid) return;
      onSave(fields);
    } else {
      if (!isChanged) return;
      onSave(selectedValue);
    }

    onClose();
  };

  return (
    <Modal open={open} handleClose={onClose} style={{ width: "385px" }}>
      {btnInfo && btnInfo?.length > 0 ? (
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "12px",
          }}
        >
          <Box mt={1}>
            {fields.map((item, index) => (
              <Box key={index} mb={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography fontSize="20px" fontWeight={500} fontFamily={"Poppins"}>
                    {item.btnName}
                  </Typography>

                  {item.showCross && (
                    <IconButton
                      onClick={onClose}
                      sx={{
                        padding: "4px",
                        marginRight: "-4px",
                      }}
                    >
                      <Typography fontSize="32px" fontWeight={300} color={"#8B8B8B !important"}>
                        ×
                      </Typography>
                    </IconButton>
                  )}
                </Box>
                <TextField
                  fullWidth
                  inputRef={(el) => (inputRefs.current[index] = el)}
                  placeholder={item.btnPlaceHolder}
                  value={item.value ? `${item.value}${item.suffix || ""}` : ""}
                  // value={item.value || ""}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  // InputProps={{
                  //   endAdornment: item.suffix ? <Typography sx={{ fontSize: "14px", color: "#8B8B8B", mr: 1 }}>{item.suffix}</Typography> : null,
                  // }}
                  onClick={() => handleCursor(index)}
                  onKeyUp={() => handleCursor(index)}
                  sx={{
                    mt: 1,

                    "& .MuiOutlinedInput-root": {
                      borderRadius: "5px",
                      height: "44px",
                      backgroundColor: "#FFFFFF",
                      padding: "3px",
                      color: "#000000",
                      "& fieldset": {
                        border: "1px solid #000000",
                      },
                      "&:hover fieldset": {
                        border: "1px solid #000000",
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid #000000",
                      },
                    },
                    "& input::placeholder": {
                      fontFamily: "Karla",
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      opacity: 1,
                      color: "#8B8B8B",
                    },
                    "& input": {
                      fontFamily: "Karla",
                      fontWeight: 500,
                      fontSize: "18px",
                    },
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            // flexGrow:1,
            ...(openState && {
              height: placeHolder !== "Choose Printer" ? "310px" : "260px",
            }),
          }}
        >
          {/* Header */}
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography fontWeight={500} fontFamily={"Poppins"} fontSize={"24px"}>
              {title}
            </Typography>
            <IconButton
              onClick={onClose}
              sx={{
                padding: "4px",
                marginRight: "-4px",
              }}
            >
              <Typography fontSize="22px" fontWeight={500} color={"#8B8B8B !important"}>
                ×
              </Typography>
            </IconButton>
          </Box>

          {/* Your Custom Select */}
          <Box mt={2}>
            <CustomSelect
              value={selectedValue}
              onChange={handleChange}
              options={options}
              onOpenChange={(isOpen) => {
                setOpenState(isOpen);
                console.log("List Open:", isOpen);
              }}
              placeholder={placeHolder ? placeHolder : `Select ${title}`}
              name={name}
              menuStyles={{
                maxHeight: "200px",
                overflowY: "auto",
                width: "fit-content",
              }}
              width={"100%"}
              customStyles={{
                height: "44px",
              }}
            />
          </Box>
        </Box>
      )}
      {/* Save Button */}
      <Box
        onClick={handleSave}
        sx={{
          mt: 3,
          height: "44px",
          borderRadius: "6px",
          backgroundColor: isValid ? "#50C878" : "#444444",
          color: "#000",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Poppins",
          cursor: isValid ? "pointer" : "not-allowed",
          fontWeight: 500,
          fontSize: "18px",
        }}
      >
        {btnTitle || "Print"}
      </Box>
    </Modal>
  );
};

export default EditSelectModal;
